export enum InventoryReferenceCodeType {
  SECTION = 'SECTION',
  ROW = 'ROW',
  SEAT = 'SEAT',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/admin/inventory-reference-code-type.ts